var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavvipalLogoWit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "3ca4688c14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.835938 165.996094 L 84.585938 165.996094 L 84.585938 208.746094 L 41.835938 208.746094 Z M 41.835938 165.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f84d0f18c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.339844 204.390625 C 54.011719 204.390625 46.449219 196.828125 46.449219 187.5 C 46.449219 178.171875 54.011719 170.609375 63.339844 170.609375 C 72.667969 170.609375 80.230469 178.171875 80.230469 187.5 C 80.230469 196.828125 72.667969 204.390625 63.339844 204.390625 Z M 63.339844 165.996094 C 51.464844 165.996094 41.835938 175.621094 41.835938 187.5 C 41.835938 199.375 51.464844 209.003906 63.339844 209.003906 C 75.21875 209.003906 84.847656 199.375 84.847656 187.5 C 84.847656 175.621094 75.21875 165.996094 63.339844 165.996094 Z M 63.339844 165.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.00000365084,
    gradientTransform: "matrix(0.0703547, 0, 0, 0.0703547, 41.835517, 165.994796)",
    y1: 305.66699,
    x2: 607.635411,
    gradientUnits: "userSpaceOnUse",
    y2: 305.66699,
    id: "38f7918aec"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.748718%, 0%, 99.998474%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.683105%, 0%, 99.89624%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.55188%, 0%, 99.691772%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.419128%, 0%, 99.485779%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.287903%, 0%, 99.281311%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.156677%, 0%, 99.076843%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.025452%, 0%, 98.87085%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.8927%, 0%, 98.666382%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.761475%, 0%, 98.461914%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.630249%, 0%, 98.25592%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.499023%, 0%, 98.051453%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.366272%, 0%, 97.846985%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.235046%, 0%, 97.640991%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.103821%, 0%, 97.436523%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.971069%, 0%, 97.23053%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.839844%, 0%, 97.026062%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.708618%, 0%, 96.821594%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.577393%, 0%, 96.615601%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.444641%, 0%, 96.411133%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.313416%, 0%, 96.206665%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.18219%, 0%, 96.000671%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.049438%, 0%, 95.796204%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.918213%, 0%, 95.591736%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.786987%, 0%, 95.385742%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.655762%, 0%, 95.181274%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.52301%, 0%, 94.975281%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.391785%, 0%, 94.770813%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.260559%, 0%, 94.566345%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.127808%, 0%, 94.360352%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.996582%, 0%, 94.155884%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.865356%, 0%, 93.951416%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.734131%, 0%, 93.745422%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.601379%, 0%, 93.540955%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.470154%, 0%, 93.336487%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.338928%, 0%, 93.130493%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.206177%, 0%, 92.926025%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.074951%, 0%, 92.721558%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.943726%, 0%, 92.515564%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.8125%, 0%, 92.311096%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.679749%, 0%, 92.105103%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.548523%, 0%, 91.900635%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.417297%, 0%, 91.696167%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.284546%, 0%, 91.490173%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.15332%, 0%, 91.285706%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.022095%, 0%, 91.081238%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.890869%, 0%, 90.875244%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.758118%, 0%, 90.670776%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.626892%, 0%, 90.466309%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.495667%, 0%, 90.260315%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.362915%, 0%, 90.055847%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.231689%, 0%, 89.849854%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.100464%, 0%, 89.645386%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.969238%, 0%, 89.440918%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.836487%, 0%, 89.234924%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.705261%, 0%, 89.030457%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.574036%, 0%, 88.825989%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.441284%, 0%, 88.619995%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.310059%, 0%, 88.415527%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.178833%, 0%, 88.21106%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.047607%, 0%, 88.005066%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.914856%, 0%, 87.800598%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.78363%, 0%, 87.59613%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.652405%, 0%, 87.390137%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.519653%, 0%, 87.185669%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.388428%, 0%, 86.979675%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.257202%, 0%, 86.775208%)",
    offset: 0.507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.125977%, 0%, 86.57074%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.993225%, 0%, 86.364746%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.862%, 0%, 86.160278%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.730774%, 0%, 85.955811%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.599548%, 0%, 85.749817%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.466797%, 0%, 85.545349%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.335571%, 0%, 85.340881%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.204346%, 0%, 85.134888%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.071594%, 0%, 84.93042%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.940369%, 0%, 84.724426%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.809143%, 0%, 84.519958%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.677917%, 0%, 84.315491%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.545166%, 0%, 84.109497%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.41394%, 0%, 83.905029%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.282715%, 0%, 83.700562%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.149963%, 0%, 83.494568%)",
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.018738%, 0%, 83.2901%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.887512%, 0%, 83.085632%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.756287%, 0%, 82.879639%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.623535%, 0%, 82.675171%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.49231%, 0%, 82.470703%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.361084%, 0%, 82.264709%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.228333%, 0%, 82.060242%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.097107%, 0%, 81.854248%)",
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.965881%, 0%, 81.64978%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.834656%, 0%, 81.445312%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.701904%, 0%, 81.239319%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.570679%, 0%, 81.034851%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.439453%, 0%, 80.830383%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.306702%, 0%, 80.62439%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.175476%, 0%, 80.419922%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.04425%, 0%, 80.215454%)",
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.913025%, 0%, 80.00946%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.780273%, 0%, 79.804993%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.649048%, 0%, 79.598999%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.517822%, 0%, 79.394531%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.385071%, 0%, 79.190063%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.253845%, 0%, 78.98407%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.12262%, 0%, 78.779602%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.991394%, 0%, 78.575134%)",
    offset: 0.820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.858643%, 0%, 78.369141%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.727417%, 0%, 78.164673%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.596191%, 0%, 77.960205%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.46344%, 0%, 77.754211%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.332214%, 0%, 77.549744%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.200989%, 0%, 77.34375%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.069763%, 0%, 77.139282%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.937012%, 0%, 76.934814%)",
    offset: 0.882813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.805786%, 0%, 76.728821%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.674561%, 0%, 76.524353%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.541809%, 0%, 76.319885%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.410583%, 0%, 76.113892%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.279358%, 0%, 75.909424%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.148132%, 0%, 75.704956%)",
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.015381%, 0%, 75.498962%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.884155%, 0%, 75.294495%)",
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.75293%, 0%, 75.090027%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.621704%, 0%, 74.884033%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.488953%, 0%, 74.679565%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.357727%, 0%, 74.473572%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.226501%, 0%, 74.269104%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.09375%, 0%, 74.064636%)",
    offset: 0.992187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.962524%, 0%, 73.858643%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "53daf673a5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.5 161.660156 L 89.25 161.660156 L 89.25 213.410156 L 37.5 213.410156 Z M 37.5 161.660156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "60d5231595"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.339844 207.796875 C 52.132812 207.796875 43.046875 198.710938 43.046875 187.5 C 43.046875 176.292969 52.132812 167.203125 63.339844 167.203125 C 74.550781 167.203125 83.636719 176.292969 83.636719 187.5 C 83.636719 198.710938 74.550781 207.796875 63.339844 207.796875 Z M 63.339844 161.660156 C 49.070312 161.660156 37.5 173.230469 37.5 187.5 C 37.5 201.773438 49.070312 213.34375 63.339844 213.34375 C 77.613281 213.34375 89.183594 201.773438 89.183594 187.5 C 89.183594 173.230469 77.613281 161.660156 63.339844 161.660156 Z M 63.339844 161.660156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.0000184822,
    gradientTransform: "matrix(0.0845406, 0, 0, 0.0845406, 37.500004, 161.659326)",
    y1: 305.66699,
    x2: 611.334449,
    gradientUnits: "userSpaceOnUse",
    y2: 305.66699,
    id: "a6d71063f8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.748718%, 0%, 100%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.683105%, 0%, 99.89624%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.550354%, 0%, 99.688721%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.417603%, 0%, 99.482727%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.284851%, 0%, 99.276733%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.1521%, 0%, 99.07074%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.019348%, 0%, 98.864746%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.888123%, 0%, 98.657227%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.755371%, 0%, 98.451233%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.62262%, 0%, 98.245239%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.489868%, 0%, 98.039246%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.357117%, 0%, 97.833252%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.225891%, 0%, 97.627258%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.09314%, 0%, 97.419739%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.960388%, 0%, 97.213745%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.827637%, 0%, 97.007751%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.694885%, 0%, 96.801758%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.56366%, 0%, 96.595764%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.430908%, 0%, 96.388245%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.298157%, 0%, 96.182251%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.165405%, 0%, 95.976257%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.032654%, 0%, 95.770264%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.901428%, 0%, 95.56427%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.768677%, 0%, 95.358276%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.635925%, 0%, 95.150757%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.503174%, 0%, 94.944763%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.370422%, 0%, 94.73877%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.239197%, 0%, 94.532776%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.106445%, 0%, 94.326782%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.973694%, 0%, 94.120789%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.840942%, 0%, 93.913269%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.708191%, 0%, 93.707275%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.575439%, 0%, 93.501282%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.444214%, 0%, 93.295288%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.311462%, 0%, 93.089294%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.178711%, 0%, 92.881775%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.045959%, 0%, 92.675781%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.913208%, 0%, 92.469788%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.781982%, 0%, 92.263794%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.649231%, 0%, 92.0578%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.516479%, 0%, 91.851807%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.383728%, 0%, 91.644287%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.250977%, 0%, 91.438293%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.119751%, 0%, 91.2323%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.987%, 0%, 91.026306%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.854248%, 0%, 90.820312%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.721497%, 0%, 90.612793%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.588745%, 0%, 90.406799%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.45752%, 0%, 90.200806%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.324768%, 0%, 89.994812%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.192017%, 0%, 89.788818%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.059265%, 0%, 89.582825%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.926514%, 0%, 89.375305%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.793762%, 0%, 89.169312%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.662537%, 0%, 88.963318%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.529785%, 0%, 88.757324%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.397034%, 0%, 88.551331%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.264282%, 0%, 88.345337%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.131531%, 0%, 88.137817%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.000305%, 0%, 87.931824%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.867554%, 0%, 87.72583%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.734802%, 0%, 87.519836%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.602051%, 0%, 87.313843%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.469299%, 0%, 87.106323%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.338074%, 0%, 86.90033%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.205322%, 0%, 86.694336%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.072571%, 0%, 86.488342%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.939819%, 0%, 86.282349%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.807068%, 0%, 86.076355%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.675842%, 0%, 85.868835%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.543091%, 0%, 85.662842%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.410339%, 0%, 85.456848%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.277588%, 0%, 85.250854%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.144836%, 0%, 85.044861%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.013611%, 0%, 84.837341%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.880859%, 0%, 84.631348%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.748108%, 0%, 84.425354%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.615356%, 0%, 84.21936%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.482605%, 0%, 84.013367%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.349854%, 0%, 83.807373%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.218628%, 0%, 83.599854%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.085876%, 0%, 83.39386%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.953125%, 0%, 83.187866%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.820374%, 0%, 82.981873%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.687622%, 0%, 82.775879%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.556396%, 0%, 82.569885%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.423645%, 0%, 82.362366%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.290894%, 0%, 82.156372%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.158142%, 0%, 81.950378%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.025391%, 0%, 81.744385%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.894165%, 0%, 81.538391%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.761414%, 0%, 81.330872%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.628662%, 0%, 81.124878%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.495911%, 0%, 80.918884%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.363159%, 0%, 80.712891%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.231934%, 0%, 80.506897%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.099182%, 0%, 80.300903%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.966431%, 0%, 80.093384%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.833679%, 0%, 79.88739%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.700928%, 0%, 79.681396%)",
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.568176%, 0%, 79.475403%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.436951%, 0%, 79.269409%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.304199%, 0%, 79.06189%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.171448%, 0%, 78.855896%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.038696%, 0%, 78.649902%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.905945%, 0%, 78.443909%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.774719%, 0%, 78.237915%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.641968%, 0%, 78.031921%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.509216%, 0%, 77.824402%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.376465%, 0%, 77.618408%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.243713%, 0%, 77.412415%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.112488%, 0%, 77.206421%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.979736%, 0%, 77.000427%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.846985%, 0%, 76.794434%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.714233%, 0%, 76.586914%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.581482%, 0%, 76.38092%)",
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.450256%, 0%, 76.174927%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.317505%, 0%, 75.968933%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.184753%, 0%, 75.762939%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.052002%, 0%, 75.55542%)",
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.91925%, 0%, 75.349426%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.788025%, 0%, 75.143433%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.655273%, 0%, 74.937439%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.522522%, 0%, 74.731445%)",
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.389771%, 0%, 74.525452%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.257019%, 0%, 74.317932%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.124268%, 0%, 74.111938%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.968628%, 0%, 73.869324%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.802525, 206.624986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 22.765625 -31.953125 C 26.472656 -31.953125 29.429688 -30.75 31.640625 -28.34375 C 33.847656 -25.945312 34.953125 -22.65625 34.953125 -18.46875 L 34.953125 0 L 25.3125 0 L 25.3125 -17.15625 C 25.3125 -19.269531 24.765625 -20.910156 23.671875 -22.078125 C 22.578125 -23.253906 21.109375 -23.84375 19.265625 -23.84375 C 17.410156 -23.84375 15.9375 -23.253906 14.84375 -22.078125 C 13.75 -20.910156 13.203125 -19.269531 13.203125 -17.15625 L 13.203125 0 L 3.515625 0 L 3.515625 -31.609375 L 13.203125 -31.609375 L 13.203125 -27.421875 C 14.179688 -28.816406 15.5 -29.921875 17.15625 -30.734375 C 18.820312 -31.546875 20.691406 -31.953125 22.765625 -31.953125 Z M 22.765625 -31.953125 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.975607, 206.624986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.59375 -15.859375 C 1.59375 -19.109375 2.203125 -21.957031 3.421875 -24.40625 C 4.648438 -26.863281 6.320312 -28.753906 8.4375 -30.078125 C 10.550781 -31.398438 12.910156 -32.0625 15.515625 -32.0625 C 17.742188 -32.0625 19.695312 -31.609375 21.375 -30.703125 C 23.0625 -29.796875 24.359375 -28.601562 25.265625 -27.125 L 25.265625 -31.609375 L 34.953125 -31.609375 L 34.953125 0 L 25.265625 0 L 25.265625 -4.46875 C 24.316406 -3 23.003906 -1.8125 21.328125 -0.90625 C 19.648438 0 17.695312 0.453125 15.46875 0.453125 C 12.894531 0.453125 10.550781 -0.210938 8.4375 -1.546875 C 6.320312 -2.890625 4.648438 -4.796875 3.421875 -7.265625 C 2.203125 -9.742188 1.59375 -12.609375 1.59375 -15.859375 Z M 25.265625 -15.796875 C 25.265625 -18.210938 24.59375 -20.117188 23.25 -21.515625 C 21.90625 -22.921875 20.273438 -23.625 18.359375 -23.625 C 16.429688 -23.625 14.796875 -22.929688 13.453125 -21.546875 C 12.109375 -20.171875 11.4375 -18.273438 11.4375 -15.859375 C 11.4375 -13.441406 12.109375 -11.523438 13.453125 -10.109375 C 14.796875 -8.691406 16.429688 -7.984375 18.359375 -7.984375 C 20.273438 -7.984375 21.90625 -8.679688 23.25 -10.078125 C 24.59375 -11.472656 25.265625 -13.378906 25.265625 -15.796875 Z M 25.265625 -15.796875 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.431873, 206.624986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.734375 -9.0625 L 24.578125 -31.609375 L 34.890625 -31.609375 L 23.671875 0 L 11.71875 0 L 0.515625 -31.609375 L 10.875 -31.609375 Z M 17.734375 -9.0625 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.886399, 206.624986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.734375 -9.0625 L 24.578125 -31.609375 L 34.890625 -31.609375 L 23.671875 0 L 11.71875 0 L 0.515625 -31.609375 L 10.875 -31.609375 Z M 17.734375 -9.0625 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.340926, 206.624986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.390625 -34.890625 C 6.679688 -34.890625 5.289062 -35.390625 4.21875 -36.390625 C 3.144531 -37.390625 2.609375 -38.628906 2.609375 -40.109375 C 2.609375 -41.617188 3.144531 -42.875 4.21875 -43.875 C 5.289062 -44.875 6.679688 -45.375 8.390625 -45.375 C 10.046875 -45.375 11.410156 -44.875 12.484375 -43.875 C 13.566406 -42.875 14.109375 -41.617188 14.109375 -40.109375 C 14.109375 -38.628906 13.566406 -37.390625 12.484375 -36.390625 C 11.410156 -35.390625 10.046875 -34.890625 8.390625 -34.890625 Z M 13.203125 -31.609375 L 13.203125 0 L 3.515625 0 L 3.515625 -31.609375 Z M 13.203125 -31.609375 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(259.048726, 206.624986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.203125 -27.125 C 14.140625 -28.601562 15.4375 -29.796875 17.09375 -30.703125 C 18.757812 -31.609375 20.707031 -32.0625 22.9375 -32.0625 C 25.539062 -32.0625 27.898438 -31.398438 30.015625 -30.078125 C 32.128906 -28.753906 33.800781 -26.863281 35.03125 -24.40625 C 36.257812 -21.957031 36.875 -19.109375 36.875 -15.859375 C 36.875 -12.609375 36.257812 -9.742188 35.03125 -7.265625 C 33.800781 -4.796875 32.128906 -2.890625 30.015625 -1.546875 C 27.898438 -0.210938 25.539062 0.453125 22.9375 0.453125 C 20.75 0.453125 18.8125 0 17.125 -0.90625 C 15.445312 -1.8125 14.140625 -2.984375 13.203125 -4.421875 L 13.203125 15.0625 L 3.515625 15.0625 L 3.515625 -31.609375 L 13.203125 -31.609375 Z M 27.015625 -15.859375 C 27.015625 -18.273438 26.34375 -20.171875 25 -21.546875 C 23.664062 -22.929688 22.015625 -23.625 20.046875 -23.625 C 18.117188 -23.625 16.484375 -22.921875 15.140625 -21.515625 C 13.804688 -20.117188 13.140625 -18.210938 13.140625 -15.796875 C 13.140625 -13.378906 13.804688 -11.472656 15.140625 -10.078125 C 16.484375 -8.679688 18.117188 -7.984375 20.046875 -7.984375 C 21.972656 -7.984375 23.613281 -8.691406 24.96875 -10.109375 C 26.332031 -11.523438 27.015625 -13.441406 27.015625 -15.859375 Z M 27.015625 -15.859375 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(297.504981, 206.624986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.59375 -15.859375 C 1.59375 -19.109375 2.203125 -21.957031 3.421875 -24.40625 C 4.648438 -26.863281 6.320312 -28.753906 8.4375 -30.078125 C 10.550781 -31.398438 12.910156 -32.0625 15.515625 -32.0625 C 17.742188 -32.0625 19.695312 -31.609375 21.375 -30.703125 C 23.0625 -29.796875 24.359375 -28.601562 25.265625 -27.125 L 25.265625 -31.609375 L 34.953125 -31.609375 L 34.953125 0 L 25.265625 0 L 25.265625 -4.46875 C 24.316406 -3 23.003906 -1.8125 21.328125 -0.90625 C 19.648438 0 17.695312 0.453125 15.46875 0.453125 C 12.894531 0.453125 10.550781 -0.210938 8.4375 -1.546875 C 6.320312 -2.890625 4.648438 -4.796875 3.421875 -7.265625 C 2.203125 -9.742188 1.59375 -12.609375 1.59375 -15.859375 Z M 25.265625 -15.796875 C 25.265625 -18.210938 24.59375 -20.117188 23.25 -21.515625 C 21.90625 -22.921875 20.273438 -23.625 18.359375 -23.625 C 16.429688 -23.625 14.796875 -22.929688 13.453125 -21.546875 C 12.109375 -20.171875 11.4375 -18.273438 11.4375 -15.859375 C 11.4375 -13.441406 12.109375 -11.523438 13.453125 -10.109375 C 14.796875 -8.691406 16.429688 -7.984375 18.359375 -7.984375 C 20.273438 -7.984375 21.90625 -8.679688 23.25 -10.078125 C 24.59375 -11.472656 25.265625 -13.378906 25.265625 -15.796875 Z M 25.265625 -15.796875 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(335.961246, 206.624986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.203125 -41.921875 L 13.203125 0 L 3.515625 0 L 3.515625 -41.921875 Z M 13.203125 -41.921875 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3ca4688c14)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f84d0f18c3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#38f7918aec)",
    d: "M 41.835938 165.996094 L 41.835938 208.746094 L 84.585938 208.746094 L 84.585938 165.996094 Z M 41.835938 165.996094 ",
    fillRule: "nonzero"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53daf673a5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#60d5231595)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a6d71063f8)",
    d: "M 37.5 161.660156 L 37.5 213.34375 L 89.183594 213.34375 L 89.183594 161.660156 Z M 37.5 161.660156 ",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavvipalLogoWit);
export default __webpack_public_path__ + "static/media/navvipal-logo-wit.d071f7733279eb6643005d3b2470fe0d.svg";
export { ForwardRef as ReactComponent };